import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";

type CompletePartConversionPriceEstimateDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isConfirmLoading?: boolean;
};

const CompletePartConversionPriceEstimateDialog: React.FC<
  CompletePartConversionPriceEstimateDialogProps
> = ({ isOpen, onClose, onConfirm, isConfirmLoading = false }) => {
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const handleClose = () => {
    if (isConfirmLoading) return;
    onClose();
  };

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={handleClose}
      isCentered
      size="md"
      closeOnEsc={!isConfirmLoading}
      closeOnOverlayClick={!isConfirmLoading}
    >
      <AlertDialogOverlay bg="blackAlpha.500">
        <AlertDialogContent
          mx={4}
          borderRadius="xl"
          boxShadow="xl"
          overflow="hidden"
        >
          <AlertDialogHeader
            fontSize="lg"
            fontWeight="semibold"
            color="gray.900"
            pb={2}
            pt={6}
            px={6}
          >
            Complete Part Conversion
          </AlertDialogHeader>

          <AlertDialogBody px={6} pb={2}>
            <HStack align="flex-start" spacing={3}>
              <Box
                bg="orange.50"
                borderRadius="full"
                p={2}
                flexShrink={0}
                mt={0.5}
              >
                <Icon as={FiAlertTriangle} color="orange.500" boxSize={5} />
              </Box>
              <Text
                color="gray.800"
                lineHeight="tall"
                fontSize="md"
                fontWeight="bold"
              >
                Are you sure the part conversion is completed?
              </Text>
            </HStack>
          </AlertDialogBody>

          <AlertDialogFooter px={6} pt={5} pb={6}>
            <Button
              ref={cancelRef}
              onClick={handleClose}
              variant="outline"
              borderColor="gray.300"
              color="gray.700"
              isDisabled={isConfirmLoading}
              _hover={{ bg: "gray.50" }}
            >
              Cancel
            </Button>
            <Button
              colorScheme="orange"
              bg="orange.500"
              ml={3}
              onClick={onConfirm}
              isLoading={isConfirmLoading}
              isDisabled={isConfirmLoading}
              _hover={{ bg: "orange.600" }}
            >
              Complete Part Conversion
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default CompletePartConversionPriceEstimateDialog;
